import brandLogo from "../../assets/images/tnp-logo-neon.png";
import "./BrandSpinner.css";
import { siteTexts } from "../i18n/siteTexts";

type BrandSpinnerProps = {
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
};

function joinClassNames(...classes: Array<string | undefined>) {
  return classes.filter(Boolean).join(" ");
}

export default function BrandSpinner({
  label = siteTexts.common.loading,
  size = "md",
  className,
}: BrandSpinnerProps) {
  return (
    <div
      className={joinClassNames("brand-spinner", `brand-spinner--${size}`, className)}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="brand-spinner__ring" aria-hidden="true" />
      <img className="brand-spinner__logo" src={brandLogo} alt="TNP" />
    </div>
  );
}
